import { graphql } from '../../services/graphql'
import ListPage from '../../models/ListPage'

const state = {
  input: {
    page: {
      number: 1,
      size: 20
    },
    productFilter: {
      noBarcode: false,
      noSupplier: false,
      activeProducts: true,
      outOfStock: false,
      categoryId: 0,
      supplierId: 0,
      search: ''
    }
  },
  productListPage: new ListPage({}),
  loading: true
}

const getters = {
  input(state) {
    return state.input
  },
  loading(state) {
    return state.loading
  },
  products(state) {
    return state.productListPage.items
  },
  selectedProductIds(state) {
    return state.productListPage.items.filter(product => product.selected).map(product => product.id)
  }
}

const mutations = {
  updateProductsListPage(state, productsListPage) {
    state.productListPage = productsListPage
  },

  updateLoading(state, value) {
    state.loading = value
  },

  updateCategoryId(state, value) {
    state.input.productFilter.categoryId = value
  },

  updateSupplier(state, value) {
    state.input.productFilter.supplierId = value
  },

  toggleSelectProduct(state, { productId, value }) {
    _.find(state.productListPage.items, {
      id: productId
    }).selected = value
  },

  setSyncProduct(state, { product, value }) {
    _.find(state.productListPage.items, {
      id: product.id
    }).synced = value
  },

  updateActiveProducts(state, value) {
    state.input.productFilter.activeProducts = value
  },

  updateOutOfStock(state, value) {
    state.input.productFilter.outOfStock = value
  },

  updateNoSupplier(state, value) {
    state.input.productFilter.noSupplier = value
  },

  updateNoBarcode(state, value) {
    state.input.productFilter.noBarcode = value
  },

  resetPage(state) {
    state.input.page.number = 1
  },

  prevPage(state) {
    state.input.page.number--
  },

  nextPage(state) {
    state.input.page.number++
  },

  setPageSize(state, value) {
    state.input.page.size = value
  },

  setSearchValue(state, value) {
    state.input.productFilter.search = value
  }
}

const actions = {
  getProductListPage(context) {
    context.commit('updateLoading', true)
    const GET_PRODUCT_LIST_QUERY = `
    query getPageList( $page: Page!, $productFilterInput: ProductFilterInput!) {
      productListPage( page: $page, productFilterInput: $productFilterInput) {
        current_page
        per_page
        last_page
        from
        to
        offset
        count
        hasNextPage
        hasPrevPage
        items {
          id
          name
          model
          ean
          image
          weight
          price
          quantity
          status
          warehouseStock {
            warehouse_id
            quantity
          }
          weight
          translations {
            name
          }
          supplier {
            name
          }
          lastSupplyOrder
          synced
        }
      }
    }
    `

    return graphql()
      .request(GET_PRODUCT_LIST_QUERY, {
        page: { ...context.state.input.page },
        productFilterInput: context.state.input.productFilter
      })
      .then(data => {
        data.productListPage.items.map(product => {
          return {
            ...product,
            selected: false,
            currentQuantity: product.quantity
          }
        })
        context.commit('updateProductsListPage', new ListPage(data.productListPage))
        context.commit('updateLoading', false)
      })
      .catch(err => console.error(err))
  },
  async changeSupplier(context, supplierId) {
    console.log('GETTERS', context.getters)
    let mutation = `
      mutation ChangeSupplier($productIds: [Int], $supplierId: Int) {
        changeSupplier(productIds: $productIds, supplierId: $supplierId)
      }`
    let result = await graphql().request(mutation, {
      productIds: context.getters.selectedProductIds,
      supplierId
    })
  },
  syncProduct(context, product) {
    let mutation = `mutation {
          kiCreateOrUpdateProduct(id: ${product.id}) {
            error
            message
          }
        }`
    graphql()
      .request(mutation)
      .then(data => {
        const { error, message } = data.kiCreateOrUpdateProduct
        if (error) {
        }
        context.commit('setSyncProduct', {
          product,
          value: true
        })
        product.synced = true
        // this.getProducts();
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/products/products.store.js